export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">专题精选</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              聚焦热门视频合集主题，深度挖掘优质影视内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {/* Card 1 */}
            <div className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[3/4] bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20with%20warm%20amber%20and%20coral%20gradients%2C%20abstract%20geometric%20patterns%2C%20modern%20entertainment%20platform%20aesthetic%2C%20high%20resolution%2C%20professional%2C%20warm%20atmospheric%20lighting&width=600&height=800&seq=carousel-01&orientation=portrait"
                  alt="妖精视频年度精选影视大全"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="text-xs font-medium text-accent-400 bg-black/30 rounded-full px-2.5 py-1 whitespace-nowrap">
                    年度精选
                  </span>
                  <h3 className="mt-2 text-base font-bold text-background-50 leading-snug">
                    妖精视频年度精选影视大全
                  </h3>
                  <p className="mt-1 text-xs text-background-300 line-clamp-2">
                    收录妖精视频全年最受欢迎的热门视频合集，一站式畅享年度好片
                  </p>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[3/4] bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Digital%20media%20collage%20featuring%20film%20strips%20and%20streaming%20icons%2C%20warm%20atmospheric%20lighting%2C%20elegant%20design%2C%20editorial%20quality%2C%20abstract%2C%20coral%20tone%20accents&width=600&height=800&seq=carousel-02&orientation=portrait"
                  alt="桃花视频+苹果视频双平台特辑"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="text-xs font-medium text-primary-400 bg-black/30 rounded-full px-2.5 py-1 whitespace-nowrap">
                    双平台特辑
                  </span>
                  <h3 className="mt-2 text-base font-bold text-background-50 leading-snug">
                    桃花视频+苹果视频双平台特辑
                  </h3>
                  <p className="mt-1 text-xs text-background-300 line-clamp-2">
                    两大平台联合呈现精品热门视频合集，丰富选择尽在掌握
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[3/4] bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Entertainment%20content%20showcase%20with%20layered%20visual%20elements%2C%20warm%20tones%2C%20modern%20composition%2C%20professional%20banner%20design%2C%20cinematic%20feel%2C%20gold%20and%20amber%20highlights&width=600&height=800&seq=carousel-03&orientation=portrait"
                  alt="榴莲视频新片速递合集"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="text-xs font-medium text-accent-400 bg-black/30 rounded-full px-2.5 py-1 whitespace-nowrap">
                    新片速递
                  </span>
                  <h3 className="mt-2 text-base font-bold text-background-50 leading-snug">
                    榴莲视频新片速递合集
                  </h3>
                  <p className="mt-1 text-xs text-background-300 line-clamp-2">
                    第一时间追踪榴莲视频最新热门视频合集上线动态与精品推荐
                  </p>
                </div>
              </div>
            </div>

            {/* Card 4 */}
            <div className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[3/4] bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20streaming%20service%20visual%20with%20dynamic%20flowing%20shapes%2C%20coral%20and%20gold%20color%20scheme%2C%20sophisticated%20design%2C%20high%20detail%2C%20atmospheric%2C%20warm%20ambient%20glow&width=600&height=800&seq=carousel-04&orientation=portrait"
                  alt="豆花视频+菠萝视频经典回顾"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <span className="text-xs font-medium text-secondary-300 bg-black/30 rounded-full px-2.5 py-1 whitespace-nowrap">
                    经典回顾
                  </span>
                  <h3 className="mt-2 text-base font-bold text-background-50 leading-snug">
                    豆花视频+菠萝视频经典回顾
                  </h3>
                  <p className="mt-1 text-xs text-background-300 line-clamp-2">
                    回顾两大平台经典热门视频合集，重温那些难忘的精彩影视瞬间
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}